/* eslint-disable */

import React, { Component } from 'react';
import Tables from '../Tables';
import Headers from '../Headers';
import Singleton from '../../sock';
import fetchBookNo from '../fetchCode';
import { ToastContainer } from 'react-toastr';
import Axios from 'axios';
import BooksDatatable from './booksDatatable';
import url from '../../config/url';
import LoaderComponent from '../cAjaxLoader';

import Select from 'react-select';
import 'react-select/dist/react-select.css';
const boookDetailsHeaders = ['Book Number', 'Title Id', 'Title', 'Category'];
const boookStatsHeaders = [{ title: 'Branch' }, { title: 'No. of copies' }, { title: 'Circulation Count' }];

const boookDetailsMHeaders = ['number', 'titleId', 'titleName', 'bookCategory'];

var booknos = [];

function isEmpty(obj) {
    for (var key in obj) {
        if (obj.hasOwnProperty(key))
            return false;
    }
    return true;
}

class SwapBooksSuggestion extends Component {

    constructor(props) {
        super(props);
        this.state = {
            bookno: '',
            tData: {},
            tDataBookStats: [],
            reset: false,
            showBooksStats: false,
            showStatsBtn: true,
            showRefreshBtn: false,
            showLoader: false,
            branchType: ''
        }
        this.handleRefresh = this.handleRefresh.bind(this);
        this.getBookStats = this.getBookStats.bind(this);
    }

    componentWillMount() {
        console.log('sortbooks will mount connection will begin');

        this.sock = Singleton.getInstance();
        console.log(this.sock);
    }

    componentDidMount() {
        console.log('sortbooks did mount, receive msg here');
        this.sock.onmessage = msg => {
            if (typeof (msg.data) === 'string') {
                this.fetchCode(msg.data);
            }
            else {
                FileReader.prototype.that = this;
                var reader = new FileReader();
                reader.onload = function () {
                    console.log(reader.result)
                    reader.__proto__.that.fetchCode(reader.result)
                }
                reader.readAsText(msg.data)

            }
        };

        this.sock.onerror = (err) => {
            console.log(err);
            this.refs.container.error("Could not connect to ThingMagic. Please check your connection and refresh");
        }
    }

    fetchCode(value) {
        if (booknos.length <= 1) {
            var obj = {
                value: value,
                bookno: booknos,
                start: true,
                callingFrom: "sort"
            };
            fetchBookNo(obj).then(res => {
                console.log(res);
                if (res.error) {
                    this.refs.container.error(res.data)

                }
                else {
                    this.setState({ tData: res.data })
                }
                booknos.push(res.bookno);
            }).catch(err => {
                console.log(err);

                return;
            });
        } else {
            this.refs.container.info('Please hit refresh in order to scan next book')
        }

    }

    getBookStats() {
        let booksDetails = this.state.tData;
        let branchType = this.state.branchType.value
        console.log(branchType);

        if (!branchType) {
            this.refs.container.error('Branch type not selected');
            return;
        }
        if (isEmpty(booksDetails)) {
            this.refs.container.error('Scan a book first')
            return;
        }
        console.log(booksDetails)
        let category = booksDetails.bookCategory;
        console.log(category)
        let categoryId = category.split("-")[0];
        let titleId = booksDetails.titleId;
        this.setState({ showLoader: true });
        Axios.get(url + `reports/getBranchesDataForSwapBookSuggestion?categoryId=${categoryId}&titleId=${titleId}&branchType=${branchType}`)
            .then(res => {
                let response = res.data;
                this.setState({ showLoader: false });
                if (response.status) {
                    let tData = [];
                    let bookStats = response.successObject;
                    for (let i = 0; i < bookStats.length; i++) {
                        tData.push([`${bookStats[i].branchId}-${bookStats[i].branchName}`, bookStats[i].copies, bookStats[i].circulationCount]);
                    }
                    this.setState({ showRefreshBtn: true, showBooksStats: true, showStatsBtn: false, tDataBookStats: tData })

                } else {
                    this.refs.container.error(response.errorDescription);
                }
            }).catch(err => {
                console.log(err)
                this.setState({ showLoader: false, showRefreshBtn: true });

                this.refs.container.error('Something is not right');
            })

    }

    handleRefresh() {
        booknos = [];
        this.setState({
            reset: !this.state.reset,
            tData: {},
            tDataBookStats: [],
            showBooksStats: false,
            showStatsBtn: true,
            showRefreshBtn: false
        });
    }

    componentWillUnmount() {
        booknos = [];
        console.log('sortbook unmount connection will be closed now');
        Singleton.closeSocket(this.sock);

    }

    render() {
        return (
            <div>
                <LoaderComponent showLoader={this.state.showLoader}>

                    <Headers
                        hname="Swap Books Suggestion"
                    />

                    <ToastContainer
                        ref="container"
                        className="toast-top-right"
                    />
                    <div className="row">
                        <div className="col-lg-4 col-md-4 col-sm-4">
                            <Select
                                name="branchDD"
                                style={{ marginTop: 30 }}
                                onChange={value => {
                                    this.setState({ branchType: value })
                                }}
                                value={this.state.branchType}
                                options={[{ value: 1, label: 'Company' }, { value: 2, label: 'Franchisee' }, { value: 3, label: 'All' }]}
                                searchable={true}
                                clearable={false}
                                placeholder='Select Branch Type'
                            />
                        </div>

                    </div>

                    <div className="row" style={{ margin: 5 }}>

                        <Tables
                            headers={boookDetailsHeaders}
                            mHeaders={boookDetailsMHeaders}
                            displayCount={this.input}
                            body={this.state.tData}
                            resetTable={this.state.reset}
                            tableId='bookDetails'
                        />

                        {this.state.showStatsBtn ? <button className="btn relativepos" type="button" onClick={this.getBookStats} >Get Book Stats</button> : ''}

                        {this.state.showBooksStats ?
                            <BooksDatatable
                                resetTable={this.state.reset}
                                columns={boookStatsHeaders}
                                tData={this.state.tDataBookStats}
                            /> : ''}

                    </div>
                    <div className="row">
                        <div className="col-sm-4"></div>
                        <div className="col-xs-4">
                            <div className="btngroup btn-toolbar">
                                {this.state.showRefreshBtn ? <button className="btn relativepos" type="button" onClick={this.handleRefresh}>Refresh</button> : ''}
                            </div>
                        </div>
                        <div className="col-lg-4"></div>
                    </div>
                </LoaderComponent>
            </div>

        )
    }
}

export default SwapBooksSuggestion;


// WEBPACK FOOTER //
// ./src/Components/SwapSuggestion/SwapBooksSuggestion.js